import {ServiceBase} from "../ServiceBase";
import {IAdminBannerService} from "./admin-banner-service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ISendElasticEventOptions} from "../analytics/analytics.service.interface";

export interface AdminBannerSegmentations {
    IsFTD: boolean;
    PlayerRMStatus: number;
    isPromotionPermitted: boolean;
    isHybrid: boolean;
    IsAuthenticated: boolean;
    serials: string;
    cid: string;
    states: string;
}

export class AdminBannerService extends ServiceBase implements IAdminBannerService{
    constructor(services: IServiceFactoryExtended) {
        super(services);
        if(this.adminBannerEnabled) {
            this._subscribe();

            const firstScript = this.services.configuration.servicesConfigs.Integration.adminBannerScript1;
            const secondScript = this.services.configuration.servicesConfigs.Integration.adminBannerScript2;
            this.services.sdk.loadScript({
                url: firstScript
            }).catch(err => {
                this.services.logger.error(`Failed to load admin banner script: ${firstScript}`, err);
            });
            this.services.sdk.loadScript({
                url: secondScript
            }).catch(err => {
                this.services.logger.error(`Failed to load admin banner script: ${secondScript}`, err);
            });

        }
    }

    private _subscribe() {
        document.addEventListener("bannerClickedEvent",(data) => this._onBannerClickedEvent(data && data['detail']),false);
        document.addEventListener("bannerShowedEvent",(data) => this._onBannerShowedEvent(data && data['detail']), false);
    }

    private _onBannerClickedEvent(bannerDetails) {
        this._sendAnalytics("CTA_CLICK", "B2C_CTA_click", bannerDetails?.id);

    }

    private _onBannerShowedEvent(bannerDetails) {
        this._sendAnalytics("CTA_SHOW", "B2C_CTA_show", bannerDetails?.id);
    }

    private _sendAnalytics(action: string, eventType: string, label: string) {
        let options: ISendElasticEventOptions = {
            category: "admin_banner",
            action: action,
            eventType: eventType,
            appID: "B2C",
            label: label
        };

        this.services.analytics.sendElasticInfoEvent(options, true);
    }

    public getSegmentationsForAdminBanner(): AdminBannerSegmentations {
        const userData = this.services.sdk.userData;
        return {
            IsFTD: userData.isFTD,
            PlayerRMStatus: userData.playerRMStatus,
            isPromotionPermitted: userData.IsPromotionPermitted ?? true ,//for SI Admin banner if it is  null as true..which mean if the user is not
            isHybrid: this.services.device.hybrid.isHybrid,
            IsAuthenticated: this.services.user.isAuthorized,
            serials: this.services.marketing.getMarketingData().sr?.toString() || "",
            cid: userData.cid?.toString() || '',
            states: this.services.stateOfResidenceIdentifier.getUserSelectedState(),
        }
    }

    public getConfigForAdminBanner(bannerAdminPlaceholderId: string): any {
        return {
            placeholderId: bannerAdminPlaceholderId,
            deviceCode: this.services.device.os.isMobileOS ? "mobile": "desktop",
            languageCode: this.services.language.currentLanguage
        }
    }

    get adminBannerEnabled(): boolean {
        return this.services.configuration.data.adminBanner.enabled;
    }
}